import { ReactElement } from "react";
import { Collapsible } from "radix-ui";
import { HiChevronDown } from "react-icons/hi";

import { I18nKeyType } from "@/i18n";
import { useTranslate } from "@/i18n/useTranslate";
import { cn } from "@/utils/tailwind.ts";

type SvAccordionMenuProps = {
  children: React.ReactNode;
  IconLeft?: ReactElement;
  className?: string;
} & (
  | {
      i18nKey: I18nKeyType;
      i18nOptions?: object;
      trigger?: never;
    }
  | {
      i18nKey?: never;
      i18nOptions?: never;
      trigger: string | ReactElement;
    }
);

export const SvAccordionMenu = ({
  i18nKey,
  i18nOptions,
  trigger,
  IconLeft,
  className,
  children,
}: SvAccordionMenuProps) => {
  const i18nText = useTranslate(i18nKey, i18nOptions);

  return (
    <Collapsible.Root>
      <Collapsible.Trigger asChild>
        <div className="group">
          <div
            className={cn(
              "font-inter active:text-primary hover:text-primary group-[data-state=open]:sketch-underline-primary group flex cursor-pointer flex-row items-center justify-start gap-2 text-lg leading-6 font-medium",
              className,
            )}>
            {IconLeft}
            {i18nText ?? trigger}
            <HiChevronDown className="text-primary transition-transform duration-300 group-data-[state=open]:-rotate-180" />
          </div>
        </div>
      </Collapsible.Trigger>
      <Collapsible.Content className="CollapsibleContent">
        <div className="border-secondary-100 mt-3 flex flex-col items-start gap-6 border-l-2 py-4 pl-4 md:gap-3 md:py-2">
          {children}
        </div>
      </Collapsible.Content>
    </Collapsible.Root>
  );
};
